import React from "react";

const ProgressStepper = ({ currentStep, totalSteps, visibleSteps }) => {
  // Calculate the visible current step (excluding hidden steps)
  const getVisibleCurrentStep = () => {
    let visibleStep = 0;
    for (let i = 0; i <= currentStep; i++) {
      if (![0, 14, 15, 16].includes(i)) {
        // Exclude hidden steps
        visibleStep++;
      }
    }
    return visibleStep - 1; // Subtract 1 because we want 0-based index
  };

  const visibleCurrentStep = getVisibleCurrentStep();

  return (
    <div className="progress-stepper">
      {Array.from({ length: totalSteps }, (_, index) => (
        <div key={index} className="progress-step">
          <div
            className={`progress-bar ${
              index <= visibleCurrentStep ? "progress-filled" : ""
            }`}
          />
        </div>
      ))}
    </div>
  );
};

export default ProgressStepper;
